import React from "react";
import styled from "styled-components";

const CardContainer = styled.div`
  height: 950px;
  width: 500px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  padding: 20px;
`;

const Heading = styled.h2`
  text-align: center;
  color: #364d9b;
  font-family: "Inter-Bold", Helvetica;
  font-size: 24px;
  margin-bottom: 20px;
`;

const TopPlayersContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 20px;
`;

const TopPlayer = styled.div`
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 10px;
  margin: 0 10px;
  text-align: center;
  position: relative;

  &:nth-child(1) {
    transform: translateY(-30px);
    z-index: 2;
  }
  &:nth-child(2) {
    transform: translateY(10px);
    margin-right: 50px; // Adjust for left positioning
  }
  &:nth-child(3) {
    transform: translateY(10px);
    margin-left: 50px; // Adjust for right positioning
  }
`;

const PlayerList = styled.div`
  margin-top: 20px;
`;

const PlayerItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
`;

const PlayerImage = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

const PlayerInfo = styled.div`
  flex-grow: 1;
  margin-left: 10px;
`;

const PlayerName = styled.div`
  font-weight: bold;
  color: #484453;
`;

const PlayerPoints = styled.div`
  color: #484453;
`;

export const LeaderBoard = (): JSX.Element => {
  const players = [
    { rank: 1, name: "Player One", points: 50, image: "assets/img/player1.png" },
    { rank: 2, name: "Player Two", points: 45, image: "assets/img/player2.png" },
    { rank: 3, name: "Player Three", points: 40, image: "assets/img/player3.png" },
    { rank: 4, name: "Player Four", points: 36, image: "assets/img/player4.png" },
    { rank: 5, name: "Player Five", points: 30, image: "assets/img/player5.png" },
    // Add more players as needed
  ];

  return (
    <div className="relative w-40 h-48 flex items-center justify-center">
      {/* Crown Shape */}
      <div className="absolute -top-8 w-28 h-28 bg-blue-800" style={{ clipPath: 'polygon(50% 0%, 62% 32%, 85% 25%, 73% 58%, 95% 60%, 80% 100%, 50% 85%, 20% 100%, 5% 60%, 27% 58%, 15% 25%, 38% 32%)' }}></div>

      {/* Profile Circle */}
      <div className="w-36 h-36 rounded-full overflow-hidden border-[6px] border-gray-600 bg-blue-800 flex items-center justify-center">
        <img src= "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" alt="Winner" className="w-28 h-28 rounded-full object-cover" />
      </div>

      {/* Badge */}
      <div className="absolute bottom-2 bg-gray-700 text-white rounded-full w-12 h-12 flex items-center justify-center text-xl">1</div>
    </div>
  );
};